import { Icon } from 'antd';
import React from 'react';
import { getIconForStatus } from '../utils';

type Props = {
    url: string;
    status?: string;
    message: string;
    relevance: number;
    hasCompetitors?: boolean;
    hideMessage?: boolean;
    hideUrl?: boolean;
};

export default function SectionMessage({ url, status, message, relevance, hasCompetitors, hideMessage, hideUrl }: Props) {
    return (
        <div className="description-content">
            {hasCompetitors && (
                <MultipleSectionMessage
                    url={url}
                    status={status}
                    message={message}
                    relevance={relevance}
                    hideMessage={hideMessage}
                    hideUrl={hideUrl}
                />
            )}

            {!hasCompetitors && <BasicSectionMessage message={message} />}
        </div>
    );
}

type BasicSectionMessageProps = {
    message: string;
};

function BasicSectionMessage({ message }: BasicSectionMessageProps) {
    return (
        <ul>
            <li>
                <div dangerouslySetInnerHTML={{ __html: message }} />
            </li>
        </ul>
    );
}

type MultipleSectionMessageProps = {
    url: string;
    message: string;
    relevance: number;
    status?: string;
    hideUrl?: boolean;
    hideMessage?: boolean;
};

function MultipleSectionMessage({ url, status, message, relevance, hideUrl, hideMessage }: MultipleSectionMessageProps) {
    return (
        <>
            <div className="flexbox align-center">
                {status && relevance !== 0 && (
                    <Icon
                        type={getIconForStatus(status)}
                        theme="filled"
                        className="status-icon"
                    />
                )}
                {!hideUrl && <span className="section-result-url">{url}</span>}
            </div>
            {!hideMessage && <BasicSectionMessage message={message} />}
        </>
    );
}
